// extracted by mini-css-extract-plugin
module.exports = {"table":"AdminUsers_table__zkl8T","inactive":"AdminUsers_inactive__oK7uT"};